import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createTestDesignatedPositionLog = (payload) => post(baseURL + url.TEST_DESIGNATED_POSITION_LOG, payload);
export const getTestDesignatedPositionLogDetails = (id) => get(`${baseURL + url.TEST_DESIGNATED_POSITION_LOG}/${id}`);
export const updateTestDesignatedPositionLog = (id, payload) => put(`${baseURL + url.TEST_DESIGNATED_POSITION_LOG}/${id}`, payload);
export const deleteTestDesignatedPositionLog = (id) => remove(`${baseURL + url.TEST_DESIGNATED_POSITION_LOG}/${id}`);